import { useRecoilValue } from "recoil";

import {
  allowTimeEditInMainPickerSelector,
  isEntityAllowTimeEditInMainPicker,
  pageEntityAtom,
} from "@ryde/shared";

export const useAllowTimeEditInMainPicker = (): boolean => {
  const entity = useRecoilValue(pageEntityAtom);
  const allowTimeEditInMainPickerGlobal = useRecoilValue(
    allowTimeEditInMainPickerSelector,
  );

  return (
    isEntityAllowTimeEditInMainPicker(entity) || allowTimeEditInMainPickerGlobal
  );
};
